module.exports = __webpack_public_path__ + "static/media/client24.40db8f65.webp";